export class ServiceSettings {
  public priorityDelta: string | null;

  public constructor() {
    this.priorityDelta = null
  }
}
